// @flow
import type { ChildrenArray, Element } from 'react';
import React from 'react';
import {
  types as t,
  usePropsValidation,
} from '../validation/runtime-checks/index.js';
import color from '../color.js';
import { Heading } from '../Heading.js';
import Latex from '../Latex.js';
import { Language, English, Spanish } from '../languages.js';
import { LatexTextAtom } from '../LatexTextAtom.js';

export function SSOKeyVocabularyList(props: {|
  children: $ReadOnlyArray<Element<typeof SSOKeyVocabularyListItem>>,
|}) {
  const { failedValidation } = usePropsValidation(props, SSOKeyVocabularyList);

  if (failedValidation) return null;

  return (
    <>
      <Heading>
        <Language>
          <English>Key vocabulary</English>
          <Spanish>Vocabulario clave</Spanish>
        </Language>
      </Heading>
      <div>
        <ul style={{ padding: 0 }}>{props.children}</ul>
      </div>
    </>
  );
}

SSOKeyVocabularyList.spec = {
  children: t.minimumCount(1, t.elementType(SSOKeyVocabularyListItem)),
};

export function SSOKeyVocabularyListItem(props: {|
  children: ChildrenArray<
    string | Element<typeof Latex> | Element<typeof LatexTextAtom>,
  >,
|}) {
  const { failedValidation } = usePropsValidation(
    props,
    SSOKeyVocabularyListItem,
  );

  if (failedValidation) return null;

  return (
    <li
      style={{
        listStyle: 'none',
        display: 'inline-block',
        fontWeight: 600,
        marginRight: '1.25em',
        color: color.cloudBurst,
        fontSize: '1em',
        lineHeight: 1.375,
      }}
    >
      {props.children}
    </li>
  );
}

SSOKeyVocabularyListItem.spec = {
  children: t.childrenArray(
    t.unionOfTypes(
      t.string,
      t.elementType(Latex),
      t.elementType(LatexTextAtom),
    ),
  ),
};
